import React,{useState, useEffect} from "react";
import { Calendar, momentLocalizer } from 'react-big-calendar';
// import 'react-big-calendar/lib/css/react-big-calendar.css';
import '../../sass/styles.scss';
import moment from 'moment';

const localizer = momentLocalizer(moment);
const currentYear = new Date().getFullYear();

// Function to generate events for every Monday to Thursday of the year
const generateWeekdayEvents = () => {
  const events = [];
  const startDate = moment(`${currentYear}-01-01`).startOf('year');
  const endDate = moment(`${currentYear}-12-31`).endOf('year');

  let currentDate = startDate.clone();
  while (currentDate.isSameOrBefore(endDate)) {
    const dayOfWeek = currentDate.day();
    if (dayOfWeek >= 1 && dayOfWeek <= 4) { // Monday to Thursday
      events.push({
        title: 'Weekday Event',
        start: currentDate.toDate(),
        end: moment(currentDate).add(15, 'minutes').toDate() // End time 15 minutes after start
      });
    }
    currentDate.add(1, 'day');
  }
  return events;
};

// Function to generate news bulletin events for Monday to Friday of the year
const generateNewsBulletinEvents = () => {
  const events = [];
  const startDate = moment(`${currentYear}-01-01`).startOf('year');
  const endDate = moment(`${currentYear}-12-31`).endOf('year');

  let currentDate = startDate.clone();
  while (currentDate.isSameOrBefore(endDate)) {
    const dayOfWeek = currentDate.day();
    if (dayOfWeek >= 1 && dayOfWeek <= 5) { // Monday to Friday
      events.push({
        title: 'News Bulletin',
        start: moment(currentDate).hour(9).minute(0).toDate(), // Start time 9:00 AM
        end: moment(currentDate).hour(9).minute(15).toDate() // End time 9:15 AM
      });
    }
    currentDate.add(1, 'day');
  }
  return events;
};

// Function to generate weekly price report events for every Friday of the year
const generateWeeklyPriceReportEvents = () => {
  const events = [];
  const startDate = moment(`${currentYear}-01-01`).startOf('year');
  const endDate = moment(`${currentYear}-12-31`).endOf('year');

  let currentDate = startDate.clone();
  while (currentDate.isSameOrBefore(endDate)) {
    if (currentDate.day() === 5) { // Friday
      events.push({
        title: 'Weekly Price Report',
        start: currentDate.toDate(),
        end: moment(currentDate).add(15, 'minutes').toDate() // End time 15 minutes after start
      });
    }
    currentDate.add(1, 'day');
  }
  return events;
};

// Function to generate water report events for every Monday of the year
const generateWaterReportEvents = () => {
  const events = [];
  const startDate = moment(`${currentYear}-01-01`).startOf('year');
  const endDate = moment(`${currentYear}-12-31`).endOf('year');

  let currentDate = startDate.clone();
  while (currentDate.isSameOrBefore(endDate)) {
    if (currentDate.day() === 1) { // Monday
      events.push({
        title: 'Water Report',
        start: currentDate.toDate(),
        end: moment(currentDate).add(15, 'minutes').toDate() // End time 15 minutes after start
      });
    }
    currentDate.add(1, 'day');
  }
  return events;
};

// Function to generate fortnightly water report events on the 15th and last day of every month of the year
// Function to generate fortnightly water report events on the 15th and last day of every month of the year
const generateFortnightlyWaterReportEvents = () => {
    const events = [];
    const startDate = moment(`${currentYear}-01-01`).startOf('year');
    const endDate = moment(`${currentYear}-12-31`).endOf('year');
  
    let currentDate = startDate.clone();
    while (currentDate.isSameOrBefore(endDate)) {
      if (currentDate.date() === 15 || currentDate.date() === currentDate.clone().endOf('month').date()) {
        events.push({
          title: 'Fortnightly Water Report',
          start: currentDate.toDate(),
          end: moment(currentDate).add(15, 'minutes').toDate() // End time 15 minutes after start
        });
      }
      currentDate.add(1, 'day');
    }
    return events;
  };
  
// Function to generate PCGA Arrivals report events for the 3rd and 18th of every month except May, June, and July
const generatePCGAArrivalsReportEvents = () => {
    const events = [];
    const startDate = moment(`${currentYear}-01-01`).startOf('year');
    const endDate = moment(`${currentYear}-12-31`).endOf('year');
  
    let currentDate = startDate.clone();
    while (currentDate.isSameOrBefore(endDate)) {
      const month = currentDate.month();
      const day = currentDate.date();
      
      // Check if it's the 3rd or 18th of the month, excluding May, June, and July
      if ((day === 3 || day === 18) && !(month >= 4 && month <= 6)) { // Excluding May, June, and July (0-indexed months)
        events.push({
          title: 'PCGA Arrivals Report',
          start: currentDate.toDate(),
          end: moment(currentDate).add(15, 'minutes').toDate() // End time 15 minutes after start
        });
      }
      currentDate.add(1, 'day');
    }
    return events;
  };


  // Function to generate Export Data and Import Data events for the 15th of every month
const generateDataEvents = () => {
    const events = [];
    const startDate = moment(`${currentYear}-01-01`).startOf('year');
    const endDate = moment(`${currentYear}-12-31`).endOf('year');
  
    let currentDate = startDate.clone();
    while (currentDate.isSameOrBefore(endDate)) {
      if (currentDate.date() === 15) { // Check if it's the 15th of the month
        events.push(
          {
            title: 'Export Data',
            start: currentDate.toDate(),
            end: moment(currentDate).add(15, 'minutes').toDate() // End time 15 minutes after start
          },
          {
            title: 'Import Data',
            start: moment(currentDate).hour(12).minute(0).toDate(), // Start time 12:00 PM
            end: moment(currentDate).hour(12).minute(15).toDate() // End time 12:15 PM
          }
        );
      }
      currentDate.add(1, 'day');
    }
    return events;
  };
  
  

// Combining events from all functions
const allEventsTwo = [
//   ...generateWeekdayEvents(),
//   ...generateNewsBulletinEvents(),
  ...generateWeeklyPriceReportEvents(),
  ...generateWaterReportEvents(),
  ...generateFortnightlyWaterReportEvents(),
  ...generatePCGAArrivalsReportEvents(),
  ...generateDataEvents()
];




// export const CropCalendar = () => (
  
//     <Calendar
//       localizer={localizer}
//       events={allEvents}
//       startAccessor="start"
//       endAccessor="end"
//       style={{ height: 500 }}
//       allDayMaxRows={6}
//     />
// );


export const CropCalendar = () => {
  const [allEventsZero, setAllEventsZero] = useState([])
  const [allEvents, setAllEvents] = useState([])
  const ferrit = async() =>{
    const response = await fetch('/get-calendar-items')
    const data = await response.json()
    setAllEvents(data)
  }
  useEffect(()=>{
    ferrit()
  },[])

  useEffect(()=>{
    setAllEventsZero(allEventsTwo.concat(allEvents))
  },[allEventsZero])
  return (
   
      <Calendar
      localizer={localizer}
      events={allEventsZero}
      startAccessor="start"
      endAccessor="end"
      style={{ height: 500 }}
      allDayMaxRows={6}
    />
  
  );
};

// export default CropCalendar;